<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const categoryUse = [
  "Moral-based stories ki quick revision",
  "Story structure samajhne ke liye",
  "Board writing section ke common prompt types",
  "Story writing ki practice ke liye",
];

const commonStoryTypes = [
  "A moral story from a proverb",
  "A story from a given outline",
  "A story ending with a clear moral",
  "A short narrative with problem and solution",
];

const examTips = [
  "Story ko sequence me likho: start, conflict, solution, moral.",
  "Moral last line me clear dena scoring hota hai.",
  "Simple language aur short plot exam me zyada effective hota hai.",
];

const commonPrompts = [
  "A thirsty crow",
  "Greed is a curse",
  "Union is strength",
  "As you sow, so shall you reap",
  "Slow and steady wins the race",
];

const storyFramework = [
  "Characters ko ek ya do lines me introduce karo.",
  "Problem ya challenge ko quickly set karo.",
  "Action aur turning point short paragraphs me likho.",
  "Ending me result aur moral clear karo.",
];

const scoringFeatures = [
  "Clear sequence",
  "Relevant title",
  "Simple grammar",
  "Strong moral line",
];

usePageSeo({
  title: "11th Class English Stories | Story Writing Support and Prompts",
  description: "11th class English stories page with common story prompts, story-writing support, quick framework and exam scoring guidance.",
  keywords: "11th class english stories, class 11 story writing, english moral stories, story prompts for 11th class",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
    { name: "Stories", item: "/11th/english/grammar/stories/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Grammar Task"
      title="Stories"
      description="Yeh page story writing ki tayari me madad karta hai. Yahan common story types, prompts aur important tips diye gaye hain."
    />

    <EnglishSection title="What You Can Study Here" description="Story writing ke liye ye cheezen sab se zyada kaam aati hain.">
      <EnglishGrid>
        <EnglishCard v-for="item in categoryUse" :key="item" title="Use Case" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Story Types" description="These are the main story patterns students should recognize.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonStoryTypes" :key="item" title="Story Type" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Board Prompts" description="Use these as quick prompt-recognition practice.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonPrompts" :key="item" title="Prompt" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Quick Story Framework" description="This sequence keeps the plot clear and scoring-friendly.">
      <EnglishGrid>
        <EnglishCard v-for="item in storyFramework" :key="item" title="Framework Step" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Exam Tips" description="These are the high-signal rules for story-writing in exam conditions.">
      <EnglishGrid>
        <EnglishCard v-for="item in examTips" :key="item" title="Tip" :description="item" />
        <EnglishCard title="What Usually Scores Better" :description="scoringFeatures.join(', ')" />
      </EnglishGrid>
      <div class="mt-3">
        <EnglishCard title="Open Story Writing Page" description="Story writing ka mukammal page kholain." to="/11th/english/grammar/story-writing/" />
      </div>
    </EnglishSection>
  </PageContainer>
</template>
